import { render, staticRenderFns } from "./CapturedImage.vue?vue&type=template&id=f63e3532&scoped=true&"
import script from "./CapturedImage.vue?vue&type=script&lang=js&"
export * from "./CapturedImage.vue?vue&type=script&lang=js&"
import style0 from "./CapturedImage.vue?vue&type=style&index=0&id=f63e3532&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f63e3532",
  null
  
)

export default component.exports